import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { Input } from "~/components/input";

import type { FormState } from "./form-state";
import { MAX } from "./settings";

export interface WidgetFontSizeProps {
	name: string;
	fontSize: FormState;
}

export const WidgetFontSize: React.FC<WidgetFontSizeProps> = ({ name, fontSize }) => {
	const monitor = useMonitor();

	return (
		<Input
			max={MAX}
			name={name}
			onChange={(event) => fontSize.setInput(event.target.value)}
			placeholder="Auto"
			type="number"
			value={fontSize.getInput(monitor)}
		/>
	);
};
